<template>
  <div class="aside_snb">
    <!-- BASE MENU OPTIONS SHOWN IN LIBRARY -->
    <div v-if="$route.path.includes('library')" class="snb_menu">
      <div class="snb_box user_name">
        <span class="base_NM18"> {{ getCurrentUser.memberNm }} 님 </span>
        <!-- <span class="snb_tit snb_tit2">
          {{ $t('library.sidebar.588')
          }}<span class="amount">{{
            $t('library.sidebar.8134', { '1': getBookshelfCount })
          }}</span>
        </span> -->
      </div>
      <div class="snb_box">
        <ul class="snb_sub">
          <ListItem :key="''" :bookshelf="emptyBookshelf" />
        </ul>
        <ul v-if="!isBookshelfLoading" class="snb_sub">
          <ListItem
            v-for="bookshelf in staticBookshelves"
            :key="bookshelf.id"
            :bookshelf="bookshelf"
            @openEditModal="openEditModal(bookshelf)"
            @openDeleteModal="openDeleteModal(bookshelf)"
          />
        </ul>
        <ul v-if="!isBookshelfLoading" class="snb_sub">
          <ListItem
            v-for="bookshelf in baseBookshelves"
            :key="bookshelf.id"
            :bookshelf="bookshelf"
            @openEditModal="openEditModal(bookshelf)"
            @openDeleteModal="openDeleteModal(bookshelf)"
          />
          <span></span>
        </ul>
        <div class="snb_insert">
          <button type="button" class="btn_insert" @click="openNewModal">
            <span>{{ $t('library.sidebar.1381') }}</span>
            <span class="svg_insert"></span>
          </button>
        </div>
        <div class="border"></div>
      </div>
    </div>

    <!-- BELOW MENU OPTIONS ARE SHOWN ON SOME /HELP/~ PAGES. INCLUDING /help/notices -->
    <div v-if="!$route.path.includes('library')" class="snb_menu_area">
      <div v-if="getCurrentUser" class="snb_box user_name">
        <span class="base_NM18">{{ getCurrentUser.memberNm }} 님</span>
      </div>
      <div class="snb_menu">
        <div class="snb_box">
          <p class="snb_tit">{{ $t('library.sidebar.4997') }}</p>
          <ul class="snb_sub">
            <li :class="{ active: $route.name === 'faq' }">
              <router-link :to="{ name: 'faq' }" class="snb_list">{{
                $t('common.footer.7188')
              }}</router-link>
              <span></span>
            </li>
            <li :class="{ active: $route.name === 'events' }">
              <router-link :to="{ name: 'events' }" class="snb_list">{{
                $t('library.sidebar.3903')
              }}</router-link>
              <span></span>
            </li>
            <li :class="{ active: $route.name === 'newsletters' }">
              <router-link :to="{ name: 'newsletters' }" class="snb_list">
                뉴스레터
              </router-link>
              <span></span>
            </li>
            <li :class="{ active: $route.name === 'notices' }">
              <router-link :to="{ name: 'notices' }" class="snb_list">{{
                $t('library.sidebar.8706')
              }}</router-link>
              <span></span>
            </li>
          </ul>
        </div>

        <div class="snb_box">
          <p class="snb_tit">{{ $t('library.sidebar.815') }}</p>
          <ul class="snb_sub">
            <li :class="{ active: $route.name === 'sitemap' }">
              <router-link :to="{ name: 'sitemap' }" class="snb_list">{{
                $t('library.sidebar.5305')
              }}</router-link>
              <span></span>
            </li>
            <li :class="{ active: $route.name === 'terms' }">
              <router-link :to="{ name: 'terms' }" class="snb_list">{{
                $t('library.sidebar.6490')
              }}</router-link>
              <span></span>
            </li>
            <li :class="{ active: $route.name === 'privacy' }">
              <router-link :to="{ name: 'privacy' }" class="snb_list">{{
                $t('library.sidebar.1298')
              }}</router-link>
              <span></span>
            </li>
          </ul>
        </div>
        <div class="snb_box">
          <p class="snb_tit">교강사 전용</p>
          <ul class="snb_sub">
            <li :class="{ active: $route.name === 'postPresent' }">
              <router-link :to="{ name: 'postPresent' }" class="snb_list"
                >증정 코드 입력</router-link
              >
              <span></span>
            </li>
            <li :class="{ active: $route.name === 'present' }">
              <router-link :to="{ name: 'present' }" class="snb_list"
                >증정 요청</router-link
              >
              <span></span>
            </li>
          </ul>
        </div>
        <div class="snb_box">
          <p class="snb_tit">일반회원 전용</p>
          <ul class="snb_sub">
            <li :class="{ active: $route.name === 'couponSecond' }">
              <router-link :to="{ name: 'couponSecond' }" class="snb_list"
                >체험판 코드 입력</router-link
              >
              <span></span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- ########### SIDEBAR END ################ -->
    <!-- NEW LIST MODAL -->
    <transition name="modal-fade">
      <CreateNewModal v-if="showNewModal" @close="closeNewModal" />
    </transition>
    <!-- // NEW LIST MODAL -->

    <!-- EDIT LIST MODAL -->
    <transition name="modal-fade">
      <EditModal
        v-if="showEditModal"
        :bookshelf="currentEditBookshelf"
        @close="closeEditModal"
      />
    </transition>
    <!-- // EDIT LIST MODAL -->

    <!-- DELETE MODAL -->
    <transition name="modal-fade">
      <DeleteModal
        v-if="showDeleteModal"
        :bookshelf="currentDeleteBookshelf"
        @close="closeDeleteModal"
      />
    </transition>
    <!-- END DELETE MODAL -->
  </div>
</template>

<script>
/**
 * 변수정리
 * BOOKSHELF_GET_LIST -> 책장목록
 * getCurrentBookshelf -> sidebar에서 선택된 서재정보 객체
 * getCurrentBookshelfBooks -> sidebar에서 선택된 서재의 책들 배열
 * getBookshelfTotalBookCount -> sidebar에서 선택된 서재의 책들 갯수
 * getBookshelves-> 현재생성되어있는 서재들모음
 * getBookshelfCount -> 생성된 책장 갯수
 * bookshelfTp -> 빈책장(UBS),구입(DBS),선물(GFT),증정(PRS),체험(CPN)
 * bookshelfNm -> 서재이름
 */
import ListItem from '@/components/library/ListItem.vue'
import CreateNewModal from '@/components/library/CreateNewModal.vue'
import EditModal from '@/components/library/EditModal.vue'
import DeleteModal from '@/components/library/DeleteModal.vue'
import { mapGetters } from 'vuex'
import { UI_CLOSE_SIDEBAR } from '@/store/types'

export default {
  name: 'Sidebar',
  components: {
    ListItem,
    CreateNewModal,
    EditModal,
    DeleteModal
  },
  data() {
    return {
      showNewModal: false,
      showEditModal: false,
      showDeleteModal: false,
      currentEditBookshelf: null,
      currentDeleteBookshelf: null
    }
  },
  computed: {
    ...mapGetters([
      'getStaticBookshelves',
      'getBookshelves',
      'isBookshelfLoading',
      'getBookshelfCount',
      'getCurrentUser',
      'isAuthLoading',
      'isShowLineBanner'
    ]),
    //책장 나누기
    staticBookshelves() {
      return this.getBookshelves.filter(
        (e) => e.bookshelfTp !== 'UBS' && e.bookshelfTp !== 'DBS'
      )
    },
    baseBookshelves() {
      return this.getBookshelves.filter(
        (e) =>
          e.bookshelfTp !== 'GFT' &&
          e.bookshelfTp !== 'PRS' &&
          e.bookshelfTp !== 'CPN'
      )
    },
    emptyBookshelf() {
      const empty = {
        bookshelfId: '',
        bookshelfNm: '전체도서',
        bookshelfTp: '',
        id: '',
        isDefault: false,
        name: '전체도서'
      }
      return empty
    }
  },
  created() {
    window.addEventListener('scroll', this.handleSCroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleSCroll)
  },
  methods: {
    closeSidebar() {
      this.$store.commit(UI_CLOSE_SIDEBAR)
    },
    closeEditMenu() {
      this.$emit('closeEditMenu')
    },
    // MODAL METHODS
    openNewModal() {
      this.showNewModal = true
    },
    closeNewModal() {
      this.showNewModal = false
    },
    // errorNewModal(error){
    //   this.closeNewModal()
    //   this.
    // },
    openEditModal(bookshelf) {
      this.currentEditBookshelf = bookshelf
      this.showEditModal = true
    },
    closeEditModal() {
      this.currentEditBookshelf = null
      this.showEditModal = false
    },
    openDeleteModal(bookshelf) {
      this.currentDeleteBookshelf = bookshelf
      this.showDeleteModal = true
    },
    closeDeleteModal() {
      this.currentDeleteBookshelf = null
      this.showDeleteModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
.aside_snb {
  min-width: 240px;
  padding-top: 60px;
  .snb_box.user_name {
    top: -54px;
    & + .snb_box {
      padding: 0 0 24px 0;
    }
  }
}
.user_name {
  position: absolute;
  top: -54px;
  padding: 22px 0px 24px 24px;
  span.base_NM18 {
    font-size: 27px;
    color: #3ab7ab;
    // border-bottom: 5px solid #36c2b5;
  }
}
.snb_menu_area {
  .user_name {
    top: 10px;
  }
}
.snb_list {
  text-align: left;
}

.snb_list span b {
  font-size: 5px;
  vertical-align: top;
  margin-right: 8px;
}
@media (max-width: 1620px) {
  .aside_snb .snb_box .snb_tit2 {
    padding-left: 5px;
  }
}
</style>
